import axios from "axios";
import { useQuery } from "react-query";
import { getDbHeader } from "../../utils2024/utils";
import { API_ENDPOINT } from "../../constants/constants";

const useCatalogueFormStatus = () => {
  return useQuery({
    queryKey: ["get-form-catalogue-status"],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}event/get-form-catalogue-status`,
        getDbHeader()
      );
      return response.data;
    },
    retry: (failureCount, error) => {
      if (!error.response) return true; // Retry on network errors
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500; // No retries for 404/500
    },
  });
};

export default useCatalogueFormStatus;
